import { redirect } from 'react-router-dom';

import { showToast } from '@/utils/toastMessage/ToastMessage';
import { Logout } from '@/utils/common';

const staticErrorMessages = {
  401: 'Unauthorized',
  400: 'Bad Request',
  403: 'Forbidden',
  404: 'Not Found',
  422: 'Unprocessable Entity',
  500: 'Ops Something went wrong!',
};

/**
 * global error handler function
 * @param {*} error
 */

const handleError = (error) => {
  try {
    const message = error?.response ?? 'Ops something went wrong!';
    switch (error?.response?.status) {
      case 400: {
        const errorMessage = message?.data.error
          ? message.data.error[0]
          : (message.data.response ?? staticErrorMessages[400]);

        showToast(errorMessage, 'error');
        break;
      }

      case 401: {
        showToast(message?.data?.detail ?? staticErrorMessages[403], 'error');
        Logout();
        break;
      }

      case 403: {
        showToast(message?.data.detail ?? staticErrorMessages[403], 'error');
        window.location.replace('/permission/denied/');
        break;
      }

      case 404: {
        showToast(message?.data.response ?? staticErrorMessages[404], 'error');
        break;
      }

      case 422: {
        showToast(message.data.detail ?? staticErrorMessages[422], 'error');
        break;
      }

      case 500: {
        showToast(message?.data.response ?? staticErrorMessages[500], 'error');
        break;
      }

      default:
        showToast(
          message?.data.response ?? 'Ops something went wrong!',
          'error',
        );
    }
  } catch (error) {
    showToast(staticErrorMessages[500], 'error');
    // Logout()
    throw new Error(error);
  }
};

export { handleError };
